@if (editMode) {
  <div>
  </div>
}
@if (!editMode) {
  <div>
    <div >
      <a data-button-deep-link style="font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 500; text-decoration: none; text-align: center; line-height: 40px; color: #fff; background-color: #4d33cc; display: inline-block; height:40px; border-radius:6px; border: 1px solid #4d33cc; padding-left: 12px; padding-right: 12px">
        {{ buttonValue }}
      </a>
    </div>
  </div>
}
